import React from 'react';
import {
  CONTENTTYPE_FILE,
  CONTENTTYPE_TEXT,
} from '../../../../../constants/api';
import { getAttr } from '../../../../../features/helpers/apiHelpers';
import {
  mapFileContentToFileItems,
  optionsMapperName,
} from '../../../../../utilities/mapperFunctions';
import { downloadFileFromUrl } from '../../../../../utilities/files';
import { BodyInformationFieldRead } from './bodyInformationField/BodyInformationFieldRead';
import { BodyInformationFieldWrite } from './bodyInformationField/BodyInformationFieldWrite';

const BodyInformationField = ({
  fieldData,
  onChange,
  isEditMode,
  validationEntity,
}) => {
  const [bodyInformationTextContent] = fieldData.textContent || [];
  const bodyInformationFiles = fieldData.fileContent || [];
  const fieldTemplates = fieldData.templates || [];

  const templateOptions = fieldTemplates.map(optionsMapperName);
  const bodyTextValue = getAttr(bodyInformationTextContent, 'textContent');
  const files = bodyInformationFiles.map(mapFileContentToFileItems);

  const onChangeText = (value) => onChange(value, CONTENTTYPE_TEXT);
  const onChangeFiles = (value, isDeleteOperation) =>
    onChange(value, CONTENTTYPE_FILE, true, isDeleteOperation);

  const onDownloadFile = (value) =>
    value && downloadFileFromUrl(value.urlToDownload, value.fileName);

  if (isEditMode) {
    return (
      <BodyInformationFieldWrite
        bodyTextValue={bodyTextValue}
        templateOptions={templateOptions}
        onChangeText={onChangeText}
        onChangeFiles={onChangeFiles}
        files={files}
        onDownloadFile={onDownloadFile}
        validationEntity={validationEntity}
      />
    );
  } else {
    return (
      <BodyInformationFieldRead
        bodyTextValue={bodyTextValue}
        files={files}
        onDownloadFile={onDownloadFile}
      />
    );
  }
};

export { BodyInformationField };
